<div class="cgi-grid">

    <!-- Account card -->
    <div class="cgi-card">
        <div class="cgi-card-title">Account</div>
        <div class="cgi-fields">
            <div class="cgi-field">
                <span class="cgi-label">First Name</span>
                <span class="cgi-value">{{ customerDetails?.firstName || '---' }}</span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">Last Name</span>
                <span class="cgi-value">{{ customerDetails?.lastName || '---' }}</span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">Customer ID</span>
                <span class="cgi-value">#{{ customerDetails?.id }}</span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">Email</span>
                <span class="cgi-value">{{ customerDetails?.email || '---' }}</span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">Phone</span>
                <span class="cgi-value">{{ customerDetails?.phoneNumber || '---' }}</span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">Language</span>
                <span class="cgi-value">{{ customerDetails?.locale || '---' }}</span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">Updated</span>
                <span class="cgi-value">{{ customerDetails?.onboardingCompletedAt | date:'d MMM' }}</span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">Document Photo</span>
                @if (customerDetails?.imageUrl) {
                <button class="cgi-link" (click)="openShowImageDialog()">Show</button>
                } @else {
                <span class="cgi-value">No image</span>
                }
            </div>
        </div>
    </div>

    <!-- Device card -->
    <div class="cgi-card">
        <div class="cgi-card-title">Device</div>
        <div class="cgi-fields">
            <div class="cgi-field">
                <span class="cgi-label">Device Type</span>
                <span class="cgi-value">{{ customerDetails?.deviceType || '---' }}</span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">App Version</span>
                <span class="cgi-value">{{ customerDetails?.appVersion || '---' }}</span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">Saved Card</span>
                <span class="cgi-value">
                    {{ (customerDetails?.paymentMethods?.length ?? 0) > 0 ? 'Yes' : 'No' }}
                </span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">FCM Token</span>
                <span class="cgi-value">{{ customerDetails?.hasFcmToken ? 'Yes' : 'No' }}</span>
            </div>
            <div class="cgi-field">
                <span class="cgi-label">Onboarding</span>
                <span class="cgi-value">{{ customerDetails?.onboardingCompleted ? 'Completed' : 'Pending' }}</span>
            </div>
        </div>
    </div>

    <!-- Customer groups card -->
    <div class="cgi-card cgi-card--full">
        <div class="cgi-card-title">Customer Groups</div>
        @if (customerDetails?.groups?.length) {
        <ul class="cgi-groups">
            @for (g of customerDetails!.groups!; track g.groupId) {
            <li>
                <a class="cgi-group" [class.cgi-group--inactive]="g.status === 'INACTIVE'"
                    [routerLink]="['/customer-groups', g.groupId]">
                    @if (g.badgeUrl) {
                    <img class="cgi-group-badge" [src]="g.badgeUrl" [alt]="g.name + ' badge'" />
                    }
                    <span class="cgi-group-name">{{ g.name }}</span>
                    @if (g.status === 'INACTIVE') { <span class="cgi-group-chip">Inactive</span> }
                </a>
            </li>
            }
        </ul>
        } @else {
        <div class="cgi-groups-empty">Not a member of any group</div>
        }
    </div>

</div>

@defer (when showImageDialog; prefetch on idle) {
<app-show-image-dialog [(visibility)]="showImageDialog" [imageUrl]="customerDetails?.imageUrl" [id]="customerDetails?.id" />
}
